import { useState } from "react";
import axios from "axios";
import { useAuthContext } from "./useAuthContext";

export const useResetPassword = () => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(null);
    const {dispatch} = useAuthContext();

    const resetPassword = async (resetCode, email, password, confirmPassword) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await axios.post(
                process.env.REACT_APP_SERVER_URL + '/api/user/reset-password', 
                {resetCode, email, password, confirmPassword}
            );
            const data = response.data;  
            //save the user to local storage
            localStorage.setItem('user', JSON.stringify(data));
            
            //update the auth context
            dispatch({type: 'LOGIN', payload: data});
                        
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            setError(e.response.data.error);   
        }
    }

    return {resetPassword, error, isLoading};
}